import { render, staticRenderFns } from "./DialogCom.vue?vue&type=template&id=e939bcc6&scoped=true&"
import script from "./DialogCom.vue?vue&type=script&lang=js&"
export * from "./DialogCom.vue?vue&type=script&lang=js&"
import style0 from "./DialogCom.vue?vue&type=style&index=0&id=e939bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e939bcc6",
  null
  
)

export default component.exports